<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Teasers >> {{formtitle}}</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field
            class="column is-4"
            label="título"
            :type="{'is-danger': errors.has('titulo')}"
            :message="errors.first('titulo')"
          >
            <b-input v-model="teaser.titulo" v-validate="'required'" name="titulo"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="descrição"
            :type="{'is-danger': errors.has('descricao')}"
            :message="errors.first('descricao')"
          >
            <b-input v-model="teaser.descricao" v-validate="'required'" name="descricao"></b-input>
          </b-field>

          <b-field class="uploadlabel video column is-4">
            <span class="span-video" v-if="teaser.video_progress === 100">Vídeo Pronto</span>
            <span class="span-video" v-else-if="teaser.video_progress === 0">Vídeo</span>
            <span class="span-video" v-else>Upload em {{ teaser.video_progress }}%</span>
            <label for="file-upload" class="uploadvideo">
              <i class="fas fa-cloud-upload-alt"></i>
              <span v-if="teaser.video_progress === 100">{{ teaser.video_url }}</span>
              <span v-else>Selecione um vídeo</span>
            </label>
            <input
              id="file-upload"
              class="button uploadvideo"
              type="file"
              @change="setVideoName($event)"
            />
          </b-field>

          <b-field
            class="column is-4"
            label="Escola"
            :type="{'is-danger': errors.has('grade')}"
            :message="errors.first('grade')"
          >
            <multiselect
              v-model="teaser.escolas"
              tag-placeholder="Adiconar escola"
              placeholder="Conteudo disponível apenas:"
              label="name"
              track-by="id"
              :options="escolas"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </b-field>

          <b-field
            class="column is-4"
            label="Tag"
            :type="{'is-danger': errors.has('grade')}"
            :message="errors.first('grade')"
          >
            <multiselect
              v-model="teaser.tags"
              tag-placeholder="Adicionar tag"
              placeholder="Procure ou adicione uma tag"
              label="nome"
              track-by="id"
              :options="options"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            ></multiselect>
          </b-field>
        </b-field>

        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{buttom}}</button>
        </div>
      </form>
    </article>
  </div>
</template>
<script>
import Upload from "@/services/UploadVideo";
import EscolaService from "@/services/EscolaService";
import TeaserService from "@/services/TeaserService";

/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
export default {
  name: "teaserform",
  props: ["teaser", "buttom", "formtitle"],
  data() {
    return {
      escolas: [],
      options: []
    };
  },
  created() {
    EscolaService.Index().then(result => {
      result.data.forEach(escola => {
        this.escolas.push({ name: escola.nome, id: escola.id });
      });
    });
    TeaserService.SearchTags().then(result => {
      result.forEach(tipo => {
        this.options.push(tipo);
      });
    });
  },
  methods: {
    addTag(newTag) {
      const tag = {
        nome: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.teaser.tags.push(tag);
    },
    setVideoName: function(event) {
      //console.log(row)
      let file = event.target.files[0];
      Upload.uploadVideo(
        file,
        uri => {
          this.teaser.video_url = uri;
        },
        progress => {
          this.teaser.video_progress = Math.floor(progress);
        }
      );
    },
    validate() {
      let err = false;
      if (this.teaser.video_progress !== 100 || this.teaser.video_url === "") {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "O video esta em upload ou sem arquivo, por favor verifique",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        err = true;
      }
      if (err) return;
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.teaser, () => {});
        }
      });
    }
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  }
};
</script>
<style scoped>
span.span-video {
  display: block;
  color: #a5220c;
  font-size: 20px;
  font-weight: 700;
  height: 20px;
  margin-bottom: 19px;
}
input.uploadvideo[type="file"] {
  display: none;
}

label.uploadvideo {
  background-color: #ebae1d;
  border-color: transparent;
  border-radius: 6px !important;
  width: 300px;
  height: 50px;
  color: #fff;
  padding: 10px 45px;
  display: block;
}

label.uploadvideo:hover {
  cursor: pointer;
}

.field.uploadlabel.video.has-addons {
  display: block;
}
</style>
